module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter8"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch8"
    }
  }, [_vm._v("Creamy Onion Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I was a teenager, I watched Julia Child prepare French onion soup on her TV program, and I was never the same. Although I grew up in an Italian home where there was never store-bought bread or canned soup, Julia brought French food into my life and I have been hooked ever since. Chances are the French onion soup you have had is a poor imitation of the real McCoy. This slow-cooker method delivers a creamier soup with lots of onions that melt during the cooking process. I recommend using a soup base or demi-glace to get full flavor, but you can still use beef broth if you prefer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup (1 stick) unsalted butter")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("5 large sweet onions, such as Vidalia, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 tablespoons sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 tablespoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ teaspoon freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("½ cup white wine (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("5 cups beef stock (see savvy)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1½ cups finely shredded Gruyère cheese for garnishing")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("turn a 5- to 7-quart slow cooker on high, add the butter and oil to the insert, cover until the butter is melted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("remove the cover and add the onions, sugar, thyme, salt, pepper, and bay leaf. Stir the onions until they are coated with the butter and seasonings.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover and cook on high for 7 to 8 hours, until they are caramelized to a deep golden brown.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("remove the cover and add the wine and beef stock. Cover and cook the soup on high for an additional 30 minutes or on low for an additional 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("remove the bay leaf before serving and garnish each serving with a sprinkling of Gruyère cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v(" white wine savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of Julia’s tricks was to use white vermouth if you don’t have any leftover white wine. It makes a good substitute and keeps in the pantry for months.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("beef stock savvy")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I recommend Superior Touch “Better than Bouillon” brand soup base (available in supermarkets or at www.superiortouch.com) or reconstituted “More than Gourmet” brand Glace de Viande Gold, which is a classic reduced brown stock (available in gourmet stores or at "), _c('a', {
    attrs: {
      "href": "http://www.morethangourmet.com",
      "target": "_blank"
    }
  }, [_vm._v("www.morethangourmet.com")]), _vm._v(".)")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49139d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/014-chapter8.vue
// module id = 96
// module chunks = 0